import { useEffect, useRef } from 'react';

/**
 * Runs a callback when the page is restored from the back/forward cache.
 *
 * OAuth-style flows set a loading state and assign `window.location.href`.
 * When the user taps Back from the provider (very common on mobile), the
 * page is restored from bfcache with that state frozen - leaving the
 * primary CTA stuck on "Preparing..." and disabled forever. Use this to
 * reset the loading state so the CTA is tappable again.
 */
export function useBfcacheRestore(onRestore: () => void) {
  const callbackRef = useRef(onRestore);
  callbackRef.current = onRestore;

  useEffect(() => {
    const handlePageshow = (event: PageTransitionEvent) => {
      if (event.persisted) {
        callbackRef.current();
      }
    };
    window.addEventListener('pageshow', handlePageshow);
    return () => window.removeEventListener('pageshow', handlePageshow);
  }, []);
}
